var map = {
	"./aceite_vegetal.svg": "659a",
	"./bosque_toks.svg": "f6e7",
	"./catedra.svg": "80b7",
	"./colaboradores.webp": "61b3",
	"./dia_grg.svg": "818a",
	"./dia_grg2.svg": "540a",
	"./director_rs.webp": "e4f5",
	"./facebook.webp": "a9f9",
	"./ficha (1).webp": "2a1e",
	"./ficha.png": "60e7",
	"./ficha.webp": "f333",
	"./fondo_verde.svg": "14f0",
	"./foto3.webp": "b75b",
	"./fundaciones.svg": "935d",
	"./grg_universidades.svg": "cba0",
	"./instagram.webp": "b9cc",
	"./lentes.svg": "54c9",
	"./libros_universidades.webp": "27d5",
	"./mermelada.webp": "d601",
	"./next.svg": "e975",
	"./next.webp": "029a",
	"./objetivo_1.webp": "4297",
	"./objetivo_11.webp": "797f",
	"./objetivo_12.webp": "f9bd",
	"./objetivo_13.webp": "b93f",
	"./objetivo_14.webp": "f641",
	"./objetivo_15.webp": "499d",
	"./objetivo_16.webp": "1f28",
	"./objetivo_17.webp": "2dcb",
	"./objetivo_2.webp": "edec",
	"./objetivo_3.webp": "8d55",
	"./objetivo_4.webp": "de6c",
	"./objetivo_5.webp": "b3fd",
	"./objetivo_6.webp": "9fd5",
	"./objetivo_7.webp": "e7d2",
	"./objetivo_8.webp": "b840",
	"./objetivo_9.webp": "ad91",
	"./objetivos_desarrollo.webp": "f9d5",
	"./objetivos_onu.webp": "d1c1",
	"./papel_reciclado.webp": "b3e5",
	"./periodo1.svg": "3469",
	"./periodo10.svg": "8db7",
	"./periodo11.svg": "2817",
	"./periodo12.svg": "1a24",
	"./periodo13.svg": "79b4",
	"./periodo14.svg": "606a",
	"./periodo15.svg": "23e0",
	"./periodo16.svg": "6e34",
	"./periodo17.svg": "5f51",
	"./periodo18.svg": "1075",
	"./periodo19.webp": "1762",
	"./periodo2.svg": "5590",
	"./periodo3.svg": "3d66",
	"./periodo4.svg": "1cd8",
	"./periodo5.svg": "9d79",
	"./periodo6.svg": "62c0",
	"./periodo7.svg": "9b82",
	"./periodo8.svg": "6c40",
	"./periodo9.svg": "431d",
	"./prev.svg": "a312",
	"./reciclado.webp": "a488",
	"./saludable.webp": "62cf",
	"./slide_interno_cafe.webp": "5455",
	"./slide_interno_chocolate.webp": "0757",
	"./slide_interno_granola.webp": "6b8c",
	"./slide_interno_huevo.webp": "ef27",
	"./slide_interno_miel.webp": "b5ca",
	"./slide_interno_nopal.webp": "eef1",
	"./slide_interno_nuez.webp": "2c5d",
	"./slide_interno_obleas.webp": "50c8",
	"./slide_interno_tisanas.webp": "60e6a",
	"./slide_interno_vainilla.webp": "305d",
	"./toner.svg": "e2e6",
	"./twitter.webp": "8985",
	"./utiles.svg": "c14f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1c1";